// context/MovimientoCajaWebSocketContext.tsx

import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import { movimientoCajaWebSocketService } from '../services/movimientoCajaWebSocketService';

interface MovimientoCajaWebSocketContextValue {
    connected: boolean;
    onMovimientoEvent: (callback: (data: any) => void) => () => void;
    /** Abre (o cambia) el canal de la sesión POS explícita. */
    connectToSession: (sesionId: number) => void;
}

const MovimientoCajaWebSocketContext = createContext<MovimientoCajaWebSocketContextValue | null>(null);

export const MovimientoCajaWebSocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [connected, setConnected] = useState(() => movimientoCajaWebSocketService.getConnected());
    const connectRef = useRef((sesionId: number) => movimientoCajaWebSocketService.connect(sesionId));

    useEffect(() => {
        // El canal se abre SOLO cuando una vista de caja indica su sesión POS
        // explícita (``connectToSession``); nunca se infiere una caja al montar.
        const unsubStatus = movimientoCajaWebSocketService.onConnectionStatus(setConnected);

        return () => {
            unsubStatus();
            // No desconectar aquí si otros componentes pueden estar usando el servicio
            // La desconexión se manejará al desmontar la app completa
        };
    }, []);

    const onMovimientoEvent = (callback: (data: any) => void) => {
        return movimientoCajaWebSocketService.on('movimiento_caja_actualizado', callback);
    };

    return (
        <MovimientoCajaWebSocketContext.Provider value={{ connected, onMovimientoEvent, connectToSession: connectRef.current }}>
            {children}
        </MovimientoCajaWebSocketContext.Provider>
    );
};

export const useMovimientoCajaWebSocket = () => {
    const ctx = useContext(MovimientoCajaWebSocketContext);
    if (!ctx) throw new Error('useMovimientoCajaWebSocket must be used within MovimientoCajaWebSocketProvider');
    return ctx;
};
